<template>
  <div :class="'alert alert-' + type" role="alert">
    <div class="alert__inner">
      <span v-if="icon" class="alert__icon">
        <i class="fa" :class="icon" />
      </span>
      <div class="alert__content">
        <span v-if="title" class="alert__title m-0">
          {{ title }}
          <span v-if="badge" class="badge badge-primary d-inline ml-1">{{ code }}</span>
        </span>
        <span v-if="subtitle" class="alert__subtitle mt-3">{{ subtitle }}</span>
        <span class="alert__info">
          <slot />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'subtitle', 'icon', 'type', 'code', 'badge']
}
</script>

<style scoped>
.badge-primary {
  font-size: 0.8rem;
}
</style>